<template>
    <button @click="click" :disabled="disabled"><slot></slot></button>
</template>

<script>
export default {
    props: ["disabled"],
    methods: {
        click(...props) {
            this.$emit("click", ...props);
        }
    }
};
</script>

<style lang="scss" scoped>
button {
    // TODO: black & white
    // TODO: disabled
    height: 25px;
    line-height: 25px;
    color: #e8e8e8;
    padding: 0 15px;
    border-radius: 20px;
    border: 1px solid #e8e8e8;
    background-color: rgba(255, 255, 255, 0);
    transition: background-color 100ms linear;
    text-transform: uppercase;

    &:hover:not([disabled]) {
        background-color: rgba(255, 255, 255, 0.3);
    }
    &:active:not([disabled]) {
        background-color: rgba(255, 255, 255, 0.4);
    }

    &[disabled] {
        cursor: not-allowed;
    }
}
</style>



// WEBPACK FOOTER //
// outline-button.vue?7b6e94b0